'use client';

import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import type { TypographyProps } from '@mui/material';
import type { FC, ReactNode } from 'react';

const StyledTypography = styled( Typography )( ({ theme }) => {
  const isLight = theme.palette.mode === 'light';

  return {
    color: isLight ? theme.palette.text.primary : theme.palette.common.white,
  };
} );

export interface ContrastedTextProps extends TypographyProps {
  children: ReactNode;
}

export const ContrastedText: FC<TypographyProps> = ({ children, ...props }) => (
  <StyledTypography {...props}>
    {children}
  </StyledTypography>
);
